import {IContentMapper} from "../base.content";
import {ListContentDTO, ListContent, ListContentItem, ListItemImage} from "../list.content";
import {LiveImage, LiveImageDTO} from "../../../image";
import {cmsStringToType, cmsTypeToString} from "../../constants";
import {parseDetails, formatDetails} from "./details";

export class ListContentMapper implements IContentMapper {
  toDTO(data: ListContent): ListContentDTO {
    return {
      type: cmsTypeToString(data.type),
      items: data.items.toArray().map((item) => ({
        primaryText: item.primaryText,
        secondaryText: item.secondaryText,
        details:formatDetails(item.details),
        avatar: item.avatar.url
      }))
    };
  }

  fromDTO(data: ListContentDTO): ListContent {
    return new ListContent({
      items: data.items.map((itemData) => {
        return new ListContentItem({
          ...itemData,
          details: parseDetails(itemData.details),
          avatar: new ListItemImage(new LiveImageDTO({
            original: itemData.avatar
          }))
        });
      })
    });
  }
}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/mappers/list.ts